let _baseUrl = process.env.VUE_APP_BASEURL;
let _webappUrl = process.env.VUE_APP_WEBAPP_URL;
let _stripeKey = process.env.VUE_APP_STRIPE_KEY;
export let baseUrl = _baseUrl;
export let webappUrl = _webappUrl;
export let stripeKey = _stripeKey;
